import React, { useState } from 'react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-tomorrow';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-min-noconflict/ext-searchbox';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/snippets/python.js';
import 'ace-builds/src-noconflict/snippets/text.js';
import 'ace-builds/webpack-resolver';

import { Languages } from 'util/appConstants';
import { useFreecodeContext, useAppContext } from 'hooks/useContext';
import { EditorContainer } from './styles';

export default function FreecodeEditorImplementation() {
  const { testImpl } = useFreecodeContext();
  const { isDarkMode } = useAppContext();

  const [value, setValue] = useState(testImpl?.challenge || 'Code not found');

  const onChange = (value) => {
    setValue(value);
  };

  return (
    <EditorContainer isDarkMode={isDarkMode}>
      <AceEditor
        placeholder="Please reset the code..."
        mode={Languages['python'].EditorName}
        theme={isDarkMode ? 'monokai' : 'tomorrow'}
        fontSize={14}
        onChange={onChange}
        value={value}
        name="solutionEditorId"
        showPrintMargin={false}
        wrapEnabled={true}
        width={'100%'}
        height={'100%'}
        editorProps={{ $blockScrolling: true }}
        enableBasicAutocompletion={true}
        enableLiveAutocompletion={true}
        enableSnippets={true}
        tabSize={4}
      />
    </EditorContainer>
  );
}
